// src/lib/api/needSubscriptionApi.ts
// Candidate job-board saved searches ("Bevakningar").

import { getApiClient } from './client';
import { NeedSubscription, NeedSubscriptionListResponse } from '../models/needSubscription';
import { JobSearchCriteria } from '../jobMatching';

const listMySubscriptions = async (): Promise<NeedSubscription[]> => {
    try {
        const data = await getApiClient().get<NeedSubscriptionListResponse>('/api/my/job-subscriptions');
        return data.subscriptions ?? [];
    } catch (error) {
        console.error('[needSubscriptionApi] Error fetching subscriptions:', error);
        return [];
    }
};

// createSubscription saves the current job-board search — the free-text query AND
// the structured filter facets (#39 Phase 2). Both are optional; an empty save
// means "watch all new postings". The criteria facets are sent flat alongside the
// query, matching CreateNeedSubscriptionRequest.
const createSubscription = async (
    name: string,
    query: string,
    criteria: JobSearchCriteria = {},
): Promise<NeedSubscription> => {
    return await getApiClient().post<NeedSubscription>('/api/my/job-subscriptions', {
        name,
        query,
        ...criteria,
    });
};

// updateSubscription renames and/or re-scopes an existing bevakning (bevakningar 2.0).
const updateSubscription = async (
    id: string,
    name: string,
    query: string,
    criteria: JobSearchCriteria = {},
): Promise<NeedSubscription> => {
    return await getApiClient().put<NeedSubscription>(`/api/my/job-subscriptions/${id}`, {
        name,
        query,
        ...criteria,
    });
};

const deleteSubscription = async (id: string): Promise<void> => {
    await getApiClient().delete<{ success: boolean }>(`/api/my/job-subscriptions/${id}`);
};

export const needSubscriptionApi = {
    listMySubscriptions,
    createSubscription,
    updateSubscription,
    deleteSubscription,
};
